import { createApiAction, showNotification } from 'services/api';
import {
  StartAction,
  SuccessAction,
  FailureAction,
} from 'services/api/redux/types';
import { Setting } from '../types';

export enum SettingsActionTypes {
  PUT_SETTINGS_START = 'tracking/put_settings_start',
  PUT_SETTINGS_SUCCESS = 'tracking/put_settings_success',
  PUT_SETTINGS_FAILURE = 'tracking/put_settings_failure',

  FETCH_SETTINGS_START = 'settings/fetch_settings_start',
  FETCH_SETTINGS_SUCCESS = 'settings/fetch_settings_success',
  FETCH_SETTINGS_FAILURE = 'settings/fetch_settings_failure',
}

export const updateSettings = (setting: Setting) =>
  createApiAction(
    {
      path: `/v1/settings`,
      method: 'PUT',
      body: setting,
    },
    putSettingsActionStart,
    putSettingsActionSuccess,
    putSettingsActionFailure
  );


const putSettingsActionStart = (): StartAction => ({
  type: SettingsActionTypes.PUT_SETTINGS_START,
  payload: null,
});

const putSettingsActionSuccess = (payload: any): SuccessAction => {
  showNotification('Settings successfully updated', {
    variant: 'success',
  });
  return {
    type: SettingsActionTypes.PUT_SETTINGS_SUCCESS,
    payload,
  };
};

const putSettingsActionFailure = (error: any): FailureAction => {
  showNotification(error.message, { variant: 'error' });
  return {
    type: SettingsActionTypes.PUT_SETTINGS_FAILURE,
    payload: { error },
  };
};

// TENANT ACTIONS
const fetchSettingsActionStart = (): StartAction => ({
  type: SettingsActionTypes.FETCH_SETTINGS_START,
  payload: null,
});

const fetchSettingsActionSuccess = (payload: any): SuccessAction => {
  return {
    type: SettingsActionTypes.FETCH_SETTINGS_SUCCESS,
    payload,
  };
};

const fetchSettingsActionFailure = (error: string): FailureAction => ({
  type: SettingsActionTypes.FETCH_SETTINGS_FAILURE,
  payload: { error },
});

export const fetchSettings = () =>
  createApiAction(
    {
      path: '/v1/settings',
      method: 'GET',
    },
    fetchSettingsActionStart,
    fetchSettingsActionSuccess,
    fetchSettingsActionFailure
  );
